import { call, put, takeEvery } from "redux-saga/effects";
import { BULK_IMPORT_SUCCESS } from "../../../../common/constant/SuccessMessage";
import * as constClass from "../../../../common/constant/constantURL";
import { get, post, put2 } from "../../../../helpers/api_helper";
import { deleteCall, postCall } from "../../../../helpers/fakebackend_helper";
import { ADD_DOMAIN, BULKIMPORT_DOMAINS, DOMAIN_DELETE, GET_DOMAINS, GET_SAMPLE_DOMIANS_CSV } from "./actionTypes";

const { getDomainsDataSuccess, getDomainsDataFailed, domainDeleteFailed, domainDeleteSuccess, addDomainSuccess, addDomainFailed, updateDomainSuccess, bulkImportDomainsFailed, bulkImportDomainsSuccess, getSampleDomainCsvFailed, getSampleDomainCsvSuccess } = require("./actions");


function* getDomainsListHandler({payload:{data}}) {
    try 
    { 
      let url= constClass.REST_API_GET_DOMAIN_DATA; 
      let responsJSON;
      if(data.keyword==null){
        responsJSON = yield call(get, url+"?pageSize="+data.pageSize+"&page="+data.page);
      }else{
         responsJSON = yield call(get, url+"?pageSize="+data.pageSize+"&page="+data.page+"&keyword="+data.keyword);
      }
      
      yield put(getDomainsDataSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(getDomainsDataFailed(error))
    }
  }

  function* deleteDomainHandler({payload:{data}}) {
    try 
    { 
      let url= constClass.REST_API_GET_DOMAIN_DATA+"?id="; 
      let responsJSON = yield call(deleteCall, url+data);
      
      
      yield put(domainDeleteSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(domainDeleteFailed(error))
    }
  }
  function* addDomainHandler({payload:{data}}) {
    try 
    { 
      let url= constClass.REST_API_GET_DOMAIN_DATA; 
      if(data.id!==undefined&&data.id!=null){
        yield call(put2, url,data);
      }else{
        yield call(post, url,data);
      }
      if(data.id!==undefined&&data.id!=null){
        yield put(updateDomainSuccess("Domain successfully updated"))
      }else{
        yield put(addDomainSuccess("Domain successfully added"))
      }
       } 
    catch (error) 
    {
      yield put(addDomainFailed(error))
    }
  }

  function* getSampleDomainsCsvHandler() {
    try 
    { 
      
      let url= constClass.REST_API_GET_DOMAIN_DATA; 
      let responsJSON = yield call(get, url+"/csv/sample");
      yield put(getSampleDomainCsvSuccess(responsJSON))
       } 
    catch (error) 
    {
      yield put(getSampleDomainCsvFailed(error))
    }
  }

  function* bulkImportDomainsHandler(data) {
    try 
    { 
      let obj=data.payload
      let url= constClass.REST_API_GET_DOMAIN_DATA; 
      yield call(postCall, url+"/csv",obj);
      yield put(bulkImportDomainsSuccess(BULK_IMPORT_SUCCESS))
       } 
    catch (error) 
    {
      yield put(bulkImportDomainsFailed(error))
    }
  }

  function* domainManagementSaga() {
    yield takeEvery (GET_DOMAINS, getDomainsListHandler);
    yield takeEvery (ADD_DOMAIN, addDomainHandler);
    yield takeEvery (DOMAIN_DELETE, deleteDomainHandler);
    yield takeEvery (GET_SAMPLE_DOMIANS_CSV, getSampleDomainsCsvHandler);
    yield takeEvery (BULKIMPORT_DOMAINS, bulkImportDomainsHandler);

  }
  export default domainManagementSaga